import { Timestamp } from "firebase/firestore";

export function getDateFromTimestamp(timestamp:Timestamp):Date {
    return timestamp.toDate();
}

export function dateToStripeTimestamp(date:Date):string {
    const newDate = date.getTime().toString();
    const dateStr = newDate.substring(0, newDate.length - 3)
    return dateStr;
}